var $class="se2--navigation-customer-journey-with-cta",$name="NavigationCustomerJourneyWithCTA",$path="app/components/NavigationCustomerJourneyWithCTA/config.js",$this={$class,$name,$path,};export const tabClassName = 'tab';
export const linkClassName = 'link';
export const ctaButtonClassName = 'cta-link';
